// Copyright © Veeam Software Group GmbH

import { useContext } from 'react';

import ResourcesContext from './ResourcesContext';

import type { Resources } from './';

export const useResources = (): Resources => useContext(ResourcesContext).resources;
